import { george, observer, ui } from "aaa";
import * as React from "react";
import { LoginManagementStore } from "./LoginManagementStore";

export const LoginManagementSite = observer(({ store }: { store: LoginManagementStore }) => {
    return <george.LoadingIndicator isLoading height={ui.windowHeight} />;
});


// WEBPACK FOOTER //
// ./src/components/loginManagement/LoginManagementSite.tsx